import { gql } from "graphql-tag"

const typeDownloadCenter = gql`
  type DownloadCenterItem {
    id: ID!
    sortOrder: Int
    categoryTitle: String
    attachments: [PDFAttachment]
  }

  type Query {
    downloadCenter(lang: String = "", cdn: Boolean = true): [DownloadCenterItem]
  }
`

export { typeDownloadCenter }

export default typeDownloadCenter
